import QRCode from 'react-qr-code';
import PlayList from './components/PlayList';
import { useDisplayConnection } from './hooks/useDisplayConnection';
import { CONFIGURATION_URL } from './config';
import { SignyLogo } from './components/SignyLogo';

function App() {
  const { connection, playlist, hubstate, blockedMessage } = useDisplayConnection();

  if (!connection) {
    if (blockedMessage) {
      return (
        <div className="flex h-screen w-full flex-col items-center justify-center space-y-8 bg-white">
          <div className="w-[300px]">
            <SignyLogo />
          </div>
          <p className="w-1/2 text-center text-lg font-semibold">{blockedMessage}</p>
        </div>
      );
    }

    return (
      <div className="flex h-screen w-full flex-col items-center justify-center space-y-8">
        <div className="w-[300px]">
          <SignyLogo />
        </div>
        {hubstate.connecting ? navigator.onLine && <p className="w-1/2 text-center text-lg font-semibold">Du är inte ansluten till internet...</p> : <p className="w-1/2 text-center text-lg font-semibold">Ansluter...</p>}
      </div>
    );
  }

  if (connection.deviceId && !connection?.displayId) {
    return (
      <div className="flex h-screen w-full flex-col items-center justify-center space-y-12">
        <div className="w-[300px]">
          <SignyLogo />
        </div>
        <QRCode value={`${CONFIGURATION_URL}/${connection.deviceId}`} />
        <p className="w-1/2 text-center text-lg font-semibold">
          Skanna QR-koden med din mobiltelefon för att konfigurera skärmen. Om du inte har en QR-läsare kan du öppna följande länk i din webbläsare:
          <br />
          {`${CONFIGURATION_URL}/${connection.deviceId}`}
        </p>
      </div>
    );
  }

  if (playlist) {
    return <PlayList playlist={playlist} />;
  }

  return (
    <div className="flex h-screen w-full flex-col items-center justify-center space-y-8 bg-white">
      <div className="w-[300px]">
        <SignyLogo />
      </div>
      {hubstate.connecting ? (
        navigator.onLine && <p className="w-1/2 text-center text-lg font-semibold">Du är inte ansluten till internet...</p>
      ) : hubstate.connected && !playlist ? (
        <p className="w-1/2 text-center text-lg font-semibold">Ingen spellista är vald att spelas på denna skärm.</p>
      ) : (
        <p className="w-1/2 text-center text-lg font-semibold">Ansluter...</p>
      )}
    </div>
  );
}

export default App;
